import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/f2ef5bfd-5866-433b-bac5-4405bb8fb383.png"
            alt="CICHORZ logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-heading font-700 text-xl tracking-wide transition-colors duration-300 ${
              scrolled ? 'text-navy-900' : 'text-white'
            }`}
            style={{ fontWeight: 700 }}
          >
            CICHORZ
          </span>
        </Link>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'text-navy-900 border-b-2 border-navy-900 pb-0.5'
                      : 'text-white border-b-2 border-white pb-0.5'
                    : scrolled
                    ? 'text-gray-600 hover:text-navy-900'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <Link
          to="/contact"
          className="hidden md:inline-flex items-center gap-2 bg-navy-900 text-white text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-navy-800 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-mail-line text-base"></i>
          Nous contacter
        </Link>

        {/* Hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
            scrolled ? 'text-navy-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <ul className="flex flex-col py-4">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`block px-6 py-3 text-sm font-medium cursor-pointer transition-colors ${
                    location.pathname === link.path
                      ? 'text-navy-900 bg-gray-50'
                      : 'text-gray-600 hover:text-navy-900 hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li className="px-6 pt-3">
              <Link
                to="/contact"
                className="block text-center bg-navy-900 text-white text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-navy-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Nous contacter
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
